import GLOBALS from '../utils/Constants';
import UserService from './users-service';

class DispatchService{
  	static sharedInstance = DispatchService.sharedInstance ? this.sharedInstance : new DispatchService();

    constructor(){
    	//initialize
	    this.credentials = UserService.sharedInstance.getStoredCredentials();
	    this.auth_username = this.credentials.username;
	    this.license = this.credentials.license;
	    this.token = this.credentials.token;
    }

    getUpdatedCrendetials(){
    	this.credentials = UserService.sharedInstance.getStoredCredentials();
	    this.auth_username = this.credentials.username;
	    this.license = this.credentials.license;
	    this.token = this.credentials.token;
    }

    //get all archived dispatches
    async getAll(){

    	this.getUpdatedCrendetials();

	  	const params = {
	        "license": this.license,
	        "auth_username": this.auth_username,
	        "token":  this.token
	    }

	    const formBody = UserService.sharedInstance.urlEncodeParams(params);
	    const response = await fetch(GLOBALS.GET_ALL_DISPATCHES_API+"&"+formBody, {
	        method: 'GET',
	        headers: {
	            'Content-Type':'application/x-www-form-urlencoded'
	        },
	    });
	    const responseJson = await response.json();
	    try {
	        UserService.sharedInstance.checkIfTokenIsValid(responseJson);
	        return responseJson;
	    } catch (error) {
	        console.error("error");
	        console.error(error);
	    }
	}

	//get all archived dispatches
    async getById(id){

    	this.getUpdatedCrendetials();

	  	const params = {
	        "license": this.license,
	        "auth_username": this.auth_username,
	        "token":  this.token,
	        "id":id
	    }

	    const formBody = UserService.sharedInstance.urlEncodeParams(params);
	    const response = await fetch(GLOBALS.GET_DISPATCH_BY_ID_API+"&"+formBody, {
	        method: 'GET',
	        headers: {
	            'Content-Type':'application/x-www-form-urlencoded'
	        },
	    });
	    const responseJson = await response.json();
	    try {
	        UserService.sharedInstance.checkIfTokenIsValid(responseJson);
	        return responseJson;
	    } catch (error) {
	        console.error("error");
	        console.error(error);
	    }
	}

	async edit(params){

        this.getUpdatedCrendetials();

	    const finalParams = {
	    	"license": this.license,
		    "token": this.token,
		    "auth_username": this.auth_username,
		    "call_type_id": params.call_type_id,
		    "facility_id":  params.facility_id,
		    "facility_location_id": params.facility_location_id,
		    "location_description": params.location_description,
		    "personnel_data": params.personnel_data,
		    "external_agency_data": params.external_agency_data,
		    "sub_user_id": params.sub_user_id,
		    "date_added": params.date_added,
		    "other_form_data": params.other_form_data,
		    "incident_narrative": params.incident_narrative,
		    "forms_data": params.forms_data,
		    "id": params.id,
		    "dispatch_number":params.dispatch_number,
		    "status":params.status
	    }

        const formBody = UserService.sharedInstance.urlEncodeParams(finalParams);

        const response = await fetch(GLOBALS.EDIT_DISPATCH_API, {
            method: 'PUT',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
            body: formBody
        });
        const responseJson = await response.json();
        //console.log("edit response", responseJson );
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("edit error:", error);
        }
    }

    async add(params){

        this.getUpdatedCrendetials();

	    const finalParams = {
	    	"license": this.license,
		    "token": this.token,
		    "auth_username": this.auth_username,
		    "call_type_id": params.call_type_id,
		    "facility_id":  params.facility_id,
		    "facility_location_id": params.facility_location_id,
		    "location_description": params.location_description,
		    "personnel_data": params.personnel_data,
		    "external_agency_data": params.external_agency_data,
		    "sub_user_id": params.sub_user_id,
		    "date_added": params.date_added,
		    "other_form_data": params.other_form_data,
		    "incident_narrative": params.incident_narrative,
		    "forms_data": params.forms_data,
		    "dispatch_number":params.dispatch_number
	    }

        const formBody = UserService.sharedInstance.urlEncodeParams(finalParams);

        const response = await fetch(GLOBALS.SAVE_DISPATCH_API, {
            method: 'POST',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
            body: formBody
        });
        const responseJson = await response.json();
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("add error:", error);
        }
    }

    async delete(id){

        this.getUpdatedCrendetials();

	    let finalParams = {
	    	"license": this.license,
		    "token": this.token,
		    "auth_username": this.auth_username,
		    "id": id
	    }

        const formBody = UserService.sharedInstance.urlEncodeParams(finalParams);

        const response = await fetch(GLOBALS.DELETE_DISPATCH_API, {
            method: 'DELETE',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
            body: formBody
        });
        const responseJson = await response.json();
        //console.log(responseJson);
        try {
            UserService.sharedInstance.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("delete error:", error);
        }
	}

	async generateDispatchID(){

		this.getUpdatedCrendetials();

		const finalParams = {
	    	"license": this.license,
		    "token": this.token,
		    "auth_username": this.auth_username
		}

		const formBody = UserService.sharedInstance.urlEncodeParams(finalParams);
		const response = await fetch(GLOBALS.GET_LAST_DISPATCH_ID_API+"&"+formBody, {
            method: 'GET',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
        });
        const responseJson = await response.json();
        console.log(responseJson);
        try {
			UserService.sharedInstance.checkIfTokenIsValid(responseJson);

			// Generate new value here:
			// Last ID + 1 - random number from 0-9999 (this is based on cirrus);
			// const data = JSON.parse(responseJson);
			const newIncidentID = parseInt(responseJson.max_id) + +1;
			const random = this.getRandomInt(999);
			const dispatchNumber = newIncidentID + '-' + random;

			console.log(newIncidentID, '-', random);

			return dispatchNumber;
            // return responseJson;
        } catch (error) {
            console.error("delete error:", error);
        }

	}

	link = async(ids) =>{
		try{
			this.getUpdatedCrendetials();

			const body = UserService.sharedInstance.urlEncodeParams({
				license: this.license,
				token: this.token,
				auth_username: this.auth_username,
				ids: JSON.stringify(ids)
			});
			const option = {
				method: 'POST',
				headers: {
					'Content-Type':'application/x-www-form-urlencoded'
				},body: body
			}
			const {LINK_DISPATCH_API} = GLOBALS;

			const response = await fetch(LINK_DISPATCH_API, option);
			const json =  await response.json();

			return json;
		}catch(err){
			console.error('Error',err);

			throw err;
		}
	}

	getRandomInt(max) {
		return Math.floor(Math.random() * Math.floor(max));
	}
}

export default DispatchService;
